export const isValidAnnouncement = (header: string, message: string): boolean =>
	header !== '' || message !== '';
export const DEFAULT_LANG_ANNOUNCEMENT_TITLE_LIMIT = 50;
export const DEFAULT_LANG_ANNOUNCEMENT_MESSAGE_LIMIT = 480;
